module.exports = __webpack_public_path__ + "img/horizontal_3_3_r_9016.84af96c3.png";